import { observer } from "mobx-react";
import * as React from "react";
import { AppIcon } from "./AppIcon";

require("../../assets/css/components/Pager.css");

interface PagerProps {
  currentPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  pageSize?: number;
}

interface PagerState { }

@observer
export class Pager extends React.Component<PagerProps, PagerState> {

  render() {
    const totalPages = Math.ceil(this.props.totalCount / this.props.pageSize);

    const handleClick = (page: number) => {
      if (page >= 1 && page <= totalPages) {
        this.props.onPageChange(page);
      }
    };

    const renderPageNumbers = () => {

      const pageNumbers = [];
      const maxPagesToShow = 3;
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      let startPage = Math.max(this.props.currentPage - halfMaxPagesToShow, 1);
      let endPage = Math.min(this.props.currentPage + halfMaxPagesToShow, totalPages);

      if (this.props.currentPage <= halfMaxPagesToShow) {
        endPage = Math.min(maxPagesToShow, totalPages);
      } else if (this.props.currentPage + halfMaxPagesToShow >= totalPages) {
        startPage = Math.max(totalPages - maxPagesToShow + 1, 1);
      }

      if (startPage > 1) {
        pageNumbers.push(
          <button key={1} onClick={() => handleClick(1)} className={1 === this.props.currentPage ? 'active' : ''}>
            1
          </button>
        );
        if (startPage > 2) {
          pageNumbers.push(
            <button key="start-ellipsis" className="separador-pager" style={{ pointerEvents: "none" }}>...</button>
          );
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => handleClick(i)}
            className={i === this.props.currentPage ? 'active btn-pager' : 'btn-pager'}
          >
            {i}
          </button>
        );
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push(
            <button key="end-ellipsis" className="separador-pager" style={{ pointerEvents: "none" }}>...</button>
          );
        }
        pageNumbers.push(
          <button
            key={totalPages}
            onClick={() => handleClick(totalPages)}
            className={totalPages === this.props.currentPage ? 'active btn-pager' : 'btn-pager'}
          >
            {totalPages}
          </button>
        );
      }

      return pageNumbers;

    };

    return (

      <div style={{ display: "flex" }}>
        <div className="pagination">
          <button onClick={() => handleClick(this.props.currentPage - 1)} disabled={this.props.currentPage === 1} className="btn-ant border-right-custom">
            <AppIcon name="keyboard_arrow_left" size={14}/> Anterior
          </button>
          {renderPageNumbers()}
          <button onClick={() => handleClick(this.props.currentPage + 1)} disabled={this.props.currentPage === totalPages || totalPages === 0} className="btn-prox border-left-custom">
            Próximo <AppIcon name="keyboard_arrow_right" size={14}/>
          </button>
        </div>
        <div className="infosPaginate" style={{ marginTop: "20px", marginLeft: 10, fontSize: 11 }}>
          {this.props.totalCount} registros
        </div>
      </div>

    );
  }
}
